import { combineReducers } from '@reduxjs/toolkit';

import fabricationReducer from 'taiwan_pcb/pcb_fabrication/slice/fabricationSlice';
import tabReducer from 'shared/product_tabs/tabs/tabSlice';
import alertReducer from 'shared/product_tabs/alert/alertSlice';
import cartReducer from 'shared/product_tabs/cart/cartSlice';
import stencilsReducer from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';
import assemblyReducer from 'shared/product_tabs/tab_assembly/slice/assemblySlice';
import bomSlice from 'shared/product_tabs/tab_parts/bomSlice';

export default combineReducers({
  fabrication: fabricationReducer,
  tab: tabReducer,
  alert: alertReducer,
  cart: cartReducer,
  stencils: stencilsReducer,
  bom: bomSlice,
  assembly: assemblyReducer,
});
